import { ListItemButton as a, ListItemIcon as s, ListItemText as e, Badge as r, ListItem as p } from "@mui/material";
import { styled as n } from "./styled2.mjs";
import { SIDE_NAV_LIST_SIZE as o } from "./constants28.mjs";
const g = n(a)`
	position: relative;
	height: ${o}px;
	border-radius: 8px;
	gap: ${({ theme: t }) => t.tokens.spacing[8]};
	padding: ${({ theme: t }) => `${t.tokens.spacing[8]} ${t.tokens.spacing[12]}`};
	background-color: ${({ theme: t, $isActive: i }) => i ? t.palette.primary.main08 : void 0};
	&:hover {
		background-color: ${({ theme: t, $isActive: i }) => i ? t.palette.primary.main08 : t.palette.grey[100]};
	}
`, $ = n(s)`
	min-width: 0;
	font-size: 16px;
	color: ${({ theme: t, $isActive: i }) => i ? t.palette.primary.main : t.palette.grey[600]};
	opacity: 0.6;
`, d = n(e)`
	margin: 0;
	color: ${({ theme: t, $isActive: i }) => i ? t.palette.primary.main : t.palette.text.primary};
	opacity: ${({ $isExpanded: t }) => t ? 1 : 0};
	transition: ${({ theme: t, $isExpanded: i }) => t.transitions.create("opacity", {
  easing: t.transitions.easing.sharp,
  duration: i ? t.transitions.duration.enteringScreen : t.transitions.duration.leavingScreen
})};
`, l = n(r)`
	width: fit-content;
	> span {
		transform: none;
		position: static;
	}
`, L = n(p)`
	height: ${o}px;
`;
export {
  l as BadgeInline,
  L as ListItem,
  g as ListItemButton,
  $ as ListItemIcon,
  d as ListItemText
};
//# sourceMappingURL=styles91.mjs.map
